import { Input_Stock_New_NoOption } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Input_Stock_New_NoOption.ts';
import {
  SpoIntlType,
  SpoType,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { Input_Stock_New_Option } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Input_Stock_New_Option.ts';
import { Input_Stock_EditNoOption } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Input_Stock_Edit_NoOption.ts';
import { Input_Stock_EditOption } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Input_Stock_Edit_Option.ts';
import { Input_Stock_Edit_Option_Intl } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Input_Stock_Edit_Option_Intl.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { formKeyMap } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { stockDataUtil } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/util.ts';
import klass from './Input_Stock.module.scss';

export type StockInput =
  | Input_Stock_New_NoOption
  | Input_Stock_New_Option
  | Input_Stock_EditNoOption
  | Input_Stock_EditOption
  | Input_Stock_Edit_Option_Intl;

export const stockInputFactory = {
  title: '재고',
  create(mode: MODE, spo: SpoType | SpoIntlType, stockType: StockType): StockInput {
    // 옵션별 수량 관리인 경우
    if (stockType === StockType.OPTION_STOCK) {
      switch (mode) {
        case MODE.NEW:
          return new Input_Stock_New_Option({
            mode: MODE.NEW,
            stock_type: StockType.OPTION_STOCK,
            name: formKeyMap.spo_items,
            value: stockDataUtil.toNewOptionData(spo),
            title: this.title,
            required: true,
            title_klass: klass.option_title,
          });

        case MODE.EDIT:
        case MODE.EDIT_TPL:
          if (stockDataUtil.isSpoIntlType(spo)) {
            throw new Error('해외배송 가능 모드가 아닌데, 영문 / 일문 인자가 존재합니다.');
          }
          return new Input_Stock_EditOption({
            mode,
            stock_type: StockType.OPTION_STOCK,
            name: formKeyMap.spo_items,
            value: stockDataUtil.toEditOptionData(spo),
            title: this.title,
            required: true,
            title_klass: klass.option_title,
          });

        case MODE.EDIT_TPL_INTL:
          if (!stockDataUtil.isSpoIntlType(spo)) {
            throw new Error('해외배송 가능 모드인데, 영문 / 일문 인자가 존재하지 않습니다.');
          }
          return new Input_Stock_Edit_Option_Intl({
            mode: MODE.EDIT_TPL_INTL,
            stock_type: StockType.OPTION_STOCK,
            name: formKeyMap.spo_items,
            value: stockDataUtil.toEditOptionIntlData(spo),
            title: this.title,
            required: true,
            title_klass: klass.option_title,
          });

        default: {
          throw new Error(`존재하지 않는 mode: ${mode}`);
        }
      }
    }

    switch (mode) {
      case MODE.NEW: {
        return new Input_Stock_New_NoOption({
          mode: MODE.NEW,
          stock_type: StockType.TOTAL_STOCK,
          name: formKeyMap.spo_items,
          value: [{ stock: 0, sku: '' }],
          title: this.title,
          required: true,
          title_klass: klass.option_title,
        });
      }
      case MODE.EDIT:
      case MODE.EDIT_TPL:
      case MODE.EDIT_TPL_INTL: {
        return new Input_Stock_EditNoOption({
          mode,
          stock_type: StockType.TOTAL_STOCK,
          name: formKeyMap.spo_items,
          value: stockDataUtil.toEditNoOptionData(spo),
          title: this.title,
          required: true,
          title_klass: klass.option_title,
        });
      }
      default: {
        throw new Error(`존재하지 않는 mode: ${mode}`);
      }
    }
  },
};
